import Link from 'next/link';
import { Instagram, Linkedin, Youtube } from '@eqi-investimentos/icons/web';
import { Divider, Flex, Text } from '@eqi-investimentos/react';
import { Thumb } from '@/components/elements/Thumb';

export const MobileFooter = () => (
  <Flex
    direction="column"
    px="m"
    py="4.5rem"
    bg="background.brand"
    gap="5xl"
    color="content.alwaysLight"
  >
    <Flex justifyContent="space-between">
      <Thumb
        src="/assets/eqi-logo-transparent.svg"
        width={77}
        height={40}
        full
        fit="contain"
        alt="Logo EQI"
      />
      <Flex direction="column" gap="2xl" alignItems="center">
        <Flex gap="xl">
          <Thumb
            src="/assets/images/reclame-aqui.png"
            width={92}
            height={33}
            full
            fit="contain"
            alt="Selo Reclame Aqui"
          />
          <Thumb
            src="/assets/images/gptw.svg"
            width={33}
            height={33}
            full
            fit="contain"
            alt="Selo Great Place to Work"
          />
        </Flex>
        <Flex gap="xl" alignItems="center">
          <Link
            href="https://www.instagram.com/eqiinvestimentos/"
            target="_blank"
          >
            <Instagram boxSize="2.25rem" />
          </Link>
          <Link
            href="https://br.linkedin.com/company/eqi-investimentos"
            target="_blank"
          >
            <Linkedin boxSize="1.5rem" />
          </Link>
          <Link
            href="https://www.youtube.com/c/eqiinvestimentos"
            target="_blank"
          >
            <Youtube boxSize="2.5rem" />
          </Link>
        </Flex>
      </Flex>
    </Flex>
    <Divider borderColor="background.brandMid" />
    <Flex direction="column" gap="m">
      <Text size="s" fontWeight="light" color="action.active.brandLight">
        A EQI Investimentos CTVM S.A., inscrita no CNPJ/ME sob o nº
        47.965.438/0001-78, é uma instituição financeira autorizada a funcionar
        pelo Banco Central do Brasil. A EQI Investimentos exime-se de
        responsabilidade por danos sofridos por seus clientes, por força de
        falha de serviços disponibilizados por terceiros. Recomendamos a todos
        os clientes a realização de cursos sobre mercado de ações para um melhor
        entendimento dos temas tratados neste canal. Toda transmissão de ordem
        pela internet está sujeita a interrupções ou atrasos, podendo impedir ou
        prejudicar o envio de ordens ou a recepção de informações atualizadas
        relacionadas a: (a) status das ordens; (b) posições de custódia, de
        operações e de limites; e (c) cotação de ativos. A EQI Investimentos é
        devidamente autorizada pela Comissão de Valores Mobiliários - CVM para o
        exercício das atividades de Coordenador de Ofertas Públicas de
        Distribuição de Valores Mobiliários, conforme Resoluções CVM 160/22 e
        161/22.
      </Text>
      <Text size="l">© 2025 EQI Investimentos CTVM S.A.</Text>
    </Flex>
  </Flex>
);
